module.exports = __webpack_public_path__ + "static/media/IMG_8760-min.e13de469.jpg";